import React from 'react';

interface MailsTabProps {
  mails: any[];
  onItemSelect?: (item: any) => void;
}

const MailsTab: React.FC<MailsTabProps> = ({ mails, onItemSelect }) => {
  if (mails.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="d-flex flex-column align-items-center">
          <i className="ti ti-mail-x fs-48 text-muted mb-3"></i>
          <h5 className="text-muted">No Office Mails</h5>
          <p className="text-muted">Your mailbox is empty.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mail-list">
      {mails.map((mail) => (
        <div key={mail.id} className="d-flex align-items-start p-3 border-bottom hover-bg-light position-relative">
          <div className="me-3">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" />
            </div>
          </div>
          <div className="me-3">
            <div className="avatar avatar-sm bg-info-transparent rounded-circle">
              <i className="ti ti-mail fs-16"></i>
            </div>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center">
                <h6 className="mb-0 fw-medium me-2">{mail.from}</h6>
                {mail.priority === 'High' && (
                  <i className="ti ti-star-filled text-warning fs-12"></i>
                )}
              </div>
              <small className="text-muted">{mail.sentDate}</small>
            </div>
            <div className="mb-2">
              <button 
                className="btn btn-link p-0 text-start text-decoration-none fw-medium text-dark"
                onClick={() => onItemSelect && onItemSelect(mail)}
              >
                {mail.subject}
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <span className={`badge ${mail.priority === 'High' ? 'bg-danger' : mail.priority === 'Medium' ? 'bg-warning' : 'bg-success'}`}>
                {mail.priority}
              </span>
              <div className="d-flex gap-2">
                <button 
                  className="btn btn-sm btn-outline-primary"
                  title="Reply"
                >
                  <i className="ti ti-arrow-back-up"></i>
                </button>
                <button 
                  className="btn btn-sm btn-outline-secondary"
                  title="Forward"
                >
                  <i className="ti ti-arrow-forward"></i>
                </button>
                <button 
                  className="btn btn-sm btn-outline-danger"
                  title="Delete"
                >
                  <i className="ti ti-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MailsTab;